import { ReactNode } from 'react';
import useIsMobile from '../../hooks/use-is-mobile';
import cn from '../../utils/classnames';
import getTextFromHtml from '../../utils/get-text-from-html';
import MaterialLongTemplate from '../material/material-long/template/material-long-template';
import ScopeOfMaterials from './components/scope-of-materials/scope-of-materials';
import './material-card.scss';

type MaterialCardProps = {
    material: Material;
    children: ReactNode;
    internalPath: string;
    className?: string;
    hideDescription?: boolean;
    itemIndex?: number;
};

const MaterialCard = (props: MaterialCardProps) => {
    const { material, className, internalPath, children, hideDescription, itemIndex } = props;

    const isMobile = useIsMobile(767);

    const cardClassNames = cn('w-100 material-card', className);
    const bottomBlockClassNames = 'd-flex material-card-bottom-block';

    return (
        <div className={cardClassNames}>
            <MaterialLongTemplate
                disablePreviewAnimation
                item={material}
                internalPath={internalPath}
                itemIndex={itemIndex}
                bottomBlock={<div className={bottomBlockClassNames}>{children}</div>}
                descriptionHtml={getTextFromHtml(material.description)!}
                extraInfo={isMobile ? <ScopeOfMaterials material={material} /> : undefined}
                hideTextInfo={hideDescription}
            />
        </div>
    );
};

export default MaterialCard;
